export function findId(arr,id){
  console.log(arr);
  console.log(id);
  for (let i = 0;i < arr.length ;i++ )
  {
    if (arr[i] == id)
    {
      return true;
    }
  }
  return false;
}

export function dealCol (vm,obj) {
  let ids = (local.getItem('IndexIds')||'').split(',') , id = obj.Id;
  //取消
  if (obj.collected===true)
  {
    vm.info = '取消收藏成功'
    ids.splice(findId(ids,id),1)
    local.setItem('IndexIds' , ids.length==0?'':ids.join(','))
    obj.collected = false;
  }else{
    //收藏
    if (ids.length>0&&ids[0]!=='')
    {
      ids.push(id)
      local.setItem('IndexIds' , ids.join(','))   
    }else{
      local.setItem('IndexIds' , id)
    }
    vm.info = '收藏成功，在已收藏查看'
   obj.collected = true;
  }
}



// WEBPACK FOOTER //
// ./src/components/public.js